import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggingService } from '../logging/logging.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

  constructor(private injector: Injector) {
    super();
  }

  manualHandleError(error: Error) {
    this.injector.get<LoggingService>(LoggingService).logException(error); // Manually log exception
    const originalError = this.getOriginalError(error);
    if (originalError !== error) {
      this.injector.get<LoggingService>(LoggingService).logException(originalError); // Manually log original exception
    }
  }
  handleError(error: any): void {
    // injecting ApplicationInsightService via injector to avoid infinite loop in case
    // error is with service itself
    this.injector.get<LoggingService>(LoggingService).logException(error);
    super.handleError(error); // optional
    // add any customer error handling here
  }
  private getOriginalError(error: any) {
    while (error && error.originalError) {
      error = error.originalError;
    }
    return (error);
  }
}
